import { memo } from "react";
import {
  Line as _Line,
  Path as _Path,
  Rect as _Rect,
  Svg as _Svg
} from "react-native-svg";
import { themed } from "../../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return <_Svg
    viewBox="0 0 256 256"
    {...otherProps}
    height={size}
    width={size}
    fill={`${color}`}
  >
    <_Rect width="256" height="256" fill="none" />
    <_Rect
      x="32"
      y="80"
      width="192"
      height="48"
      rx="8"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
    <_Path
      d="M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
    <_Line
      x1="128"
      y1="80"
      x2="128"
      y2="208"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
    <_Path
      d="M173.3,68.7C161.9,80,128,80,128,80s0-33.9,11.3-45.3a24,24,0,0,1,34,34Z"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
    <_Path
      d="M82.7,68.7C94.1,80,128,80,128,80s0-33.9-11.3-45.3a24,24,0,0,0-34,34Z"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
    <_Path
      d="M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128Z"
      opacity="0.2"
    />
  </_Svg>;
};
Icon.displayName = "GiftDuotone";
const GiftDuotone = memo(themed(Icon));
export {
  GiftDuotone
};
//# sourceMappingURL=gift-duotone.js.map
